const WOW = require('wowjs');

window.initGamesSubscriptions = (options = {
    recaptchaSiteKey,
    storeSubscriptionUrl,
    locale
}) => {
    const submitForm = $("#games-subscribe-form");
    const submitButton = $("#games-subscribe-form-submit");
    const formErrorsHandler = FormErrorsHandler("games-subscribe-form", {
        errorBoxStyle: 'padding-bottom: 5px'
    });

    const thanksModal = $("#thanks-window-subscribed");
    const thanksModalButton = $("#thanks-window-subscribed-button");

    function submitSubscription() {
        const successHandler = () => {
            thanksModal.modal({
                showClose: false
            });
        };
        const completeHandler = (xhr) => {
            if (xhr.status == 201) {
                submitForm.find("input").val("");
            } else if (xhr.status == 422) {
                formErrorsHandler.setErrors(xhr.responseJSON.errors);
            }

            submitButton.prop('disabled', false);
            $('.preloader').hide();
        };

        submitButton.prop('disabled', true);
        $.ajax({
            method: "POST",
            url: options.storeSubscriptionUrl,
            headers: {
                'locale': options.locale
            },
            dataType: "json",
            data: submitForm.serializeArray(),
            success: successHandler,
            complete: completeHandler,
        });
    }

    submitForm.submit((e) => {
        e.preventDefault();
        $('.preloader').show();
        formErrorsHandler.clearAll();

        grecaptcha.ready(() => {
            grecaptcha.execute(
                options.recaptchaSiteKey,
                {
                    action: "subscribe_games"
                }
            ).then((token) => {
                submitForm.find("input[name=g-recaptcha-response]")
                    .val(token);
                submitSubscription();
            });
        });
    });

    thanksModalButton.click(() => {
        $.modal.close();
    });

    // init parallax effect
    const scene = document.getElementById('scene');
    const parallaxInstance = new window.Parallax(scene, {
        hoverOnly: true,
    });

    // game category select
    const gamesTabs = $('.games-tabs__tab');
    const gamesCard = $('.games-tabs__items');
    gamesTabs.click((e) => {
        const target = $(e.target);
        const activeItemsCard = $(target.data('target'));
        currentTabCode = target.data('tag-code');

        gamesTabs.removeClass('games-tabs__tab-active');
        gamesCard.removeClass('games-tabs__items-active');

        activeItemsCard.addClass('games-tabs__items-active');
        target.addClass('games-tabs__tab-active');

        new WOW.WOW({
            boxClass: 'wow-games'
        }).init();

        var url = new Domurl;
        url.query.tag = currentTabCode;
        window.history.replaceState('', '', url.toString());
    });
}
